import { createTheme } from '@mui/material/styles';

const baseTheme = createTheme();

const theme = createTheme({
  ...baseTheme,
  palette: {
    primary: {
      main: '#0072e4',
      dark: '#005bb5',
      light: '#3d8edc',
      faded: 'rgba(0, 114, 228, 0.3)',
      surface: '#E3EEFB',
      contrastText: '#fff',
    },
    secondary: {
      main: '#6b6b6b',
      contrastText: '#fff',
    },
    error: {
      main: '#fb544e',
      dark: '#8C2A27',
      light: '#fd9793',
      surface: '#FEEAE9',
      contrastText: '#fff',
    },
    warning: {
      main: '#e07b00',
      dark: '#b85f00',
      light: '#fff1e0',
      contrastText: '#fff',
    },
    success: {
      main: '#66ac25',
      dark: '#4a7d1a',
      light: '#f0f7df',
      faded: 'rgba(102, 172, 37, 0.3)',
      contrastText: '#fff',
    },
    background: {
      default: '#F5F5F5',
      paper: '#FFFFFF',
      main: '#FFFFFF',
      surface: '#F3F4F6',
      tableHeader: '#EEEEEE',
    },
    text: {
      primary: '#1a1a1a',
      secondary: '#6b6b6b',
      disabled: '#9CA3AF',
      tertiary: '#4D4D4D',
    },
    border: {
      main: '#EDEDED',
      light: '#F3F4F6',
      divider: '#EFF0F6',
    },
    green: {
      main: '#66ac25',
      contrastText: '#fff',
    },
    orange: {
      main: '#E8902C',
      light: '#FDEFE0',
      contrastText: '#fff',
    },
    chart: {
      dormantRecent: '#86EFAC',
      dormantMid: '#FDE68A',
      dormantOld: '#FCA5A5',
      amber: '#F5A623',
    },
    overlay: {
      whiteLight: 'rgba(255,255,255,0.15)',
      whiteMid: 'rgba(255,255,255,0.45)',
    },
    gradient: {
      hero: 'linear-gradient(135deg, #0072e4 0%, rgba(0, 114, 228, 0.7) 100%)',
    },
  },
  shape: {
    borderRadius: 8,
  },
  components: {
    // Applique police / fond / couleur de texte de la page partout (effectif quand
    // le theme est branche globalement avec <CssBaseline />).
    MuiCssBaseline: {
      styleOverrides: {
        body: {
          fontFamily: 'Inter, system-ui, sans-serif',
          backgroundColor: '#F9FAFB',
          color: '#1a1a1a',
        },
      },
    },
    MuiButton: {
      defaultProps: { disableElevation: true },
      styleOverrides: {
        root: { textTransform: 'none', borderRadius: 8, fontFamily: 'Inter, system-ui, sans-serif' },
      },
    },
    MuiTab: {
      styleOverrides: {
        root: { textTransform: 'none', fontWeight: 600, fontFamily: 'Inter, system-ui, sans-serif' },
      },
    },
    // Cartes plates a coins arrondis, comme les blocs de la page (pas d'ombre lourde).
    MuiPaper: {
      defaultProps: { elevation: 0 },
      styleOverrides: {
        root: { backgroundImage: 'none', borderRadius: 8 },
      },
    },
    MuiCard: {
      defaultProps: { elevation: 0 },
      styleOverrides: {
        root: { borderRadius: 8, border: '1px solid #EDEDED' },
      },
    },
    MuiChip: {
      // Pas de borderRadius ici : les chips restent en pill (arrondi complet), comme la page.
      styleOverrides: {
        root: { fontFamily: 'Inter, system-ui, sans-serif' },
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: { borderRadius: 8 },
      },
    },
  },
  typography: {
    fontFamily: 'Inter, system-ui, sans-serif',
    fontSize: 14,
    h1: { fontFamily: 'Inter, system-ui, sans-serif', fontSize: 28, fontWeight: 700 },
    h2: { fontFamily: 'Inter, system-ui, sans-serif', fontSize: 22, fontWeight: 700 },
    h3: { fontFamily: 'Inter, system-ui, sans-serif', fontSize: 18, fontWeight: 700 },
    h5: { fontFamily: 'Inter, system-ui, sans-serif', fontSize: 13, fontWeight: 700 },
    body2: { fontFamily: 'Inter, system-ui, sans-serif', fontWeight: 400, fontSize: 14 },
    body3: { fontFamily: 'Inter, system-ui, sans-serif', fontSize: 12, fontWeight: 400 },
    subtitle1: { fontFamily: 'Inter, system-ui, sans-serif', fontWeight: 500, fontSize: 14 },
    subtitle2: { fontFamily: 'Inter, system-ui, sans-serif', fontSize: 13, fontWeight: 400, letterSpacing: '-0.3px' },
    secondary: { fontFamily: 'Inter, system-ui, sans-serif', color: '#6b6b6b', fontSize: 12, fontWeight: 400 },
  },
  container: {
    borderRight: '1px solid #E5E7EB',
    backgroundColor: '#fff',
    borderRadius: '20px',
    boxShadow: '0px 4px 20px 0px rgba(0, 0, 0, 0.06)',
  },
  menu: {
    backgroundColor: '#fff',
    borderRadius: '0px 20px 20px 0px',
    boxShadow: '0px 4px 20px 0px rgba(0, 0, 0, 0.06)',
  },
  divider: {
    borderColor: '#E5E7EB',
    borderWidth: 1,
    opacity: 1,
  },
  center: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
});

export default theme;
